import { useTLang } from 'intl/intl';

export function useCargoMainBtnLang() {
  return {
    cta: {
      short: useTLang({ id: 'cargo.mainBtn.cta.short' }),
      long: useTLang({ id: 'cargo.mainBtn.cta.long' }),
    },
    close: useTLang({ id: 'cargo.mainBtn.close' }),
  };
}
